export enum GuideStatusEnum {
    NovaGuia = 1,
    AguardandoAutorizacao = 2,
    Negada = 3,
    Autorizada = 4,
    Finalizada = 5,
    Cancelada = 6
}